// Compact display formatting for large counters (views, etc.) — 1000 -> "1k",
// 1300 -> "1.3k", 1300000 -> "1.3m". Values under 1000 are shown as-is.
export function formatCompactCount(count: number): string {
    const abs = Math.abs(count);
    if (abs < 1000) return String(count);

    let divisor = abs < 1_000_000 ? 1_000 : 1_000_000;
    let suffix = divisor === 1_000 ? "k" : "m";
    let scaled = parseFloat((count / divisor).toFixed(1));

    // Rounding to one decimal can push a value up to the next unit's
    // threshold (e.g. 999,950 -> "1000.0k") — bump to the next unit instead
    // of displaying an out-of-range number.
    if (Math.abs(scaled) >= 1000 && divisor === 1_000) {
        divisor = 1_000_000;
        suffix = "m";
        scaled = parseFloat((count / divisor).toFixed(1));
    }

    return `${scaled}${suffix}`;
}
